import './Tags.css'
import { audioEffects } from '../utils/audioEffects'
import { useRef } from 'react'

interface TagsProps {
  tags: string[]
  title?: string
}

function Tags({ tags, title = "Tags" }: TagsProps) {
  const lastPlayedRef = useRef<number>(0)

  const handleTagHover = () => {
    const now = Date.now()
    // Throttle to prevent too frequent sound playing (minimum 100ms between sounds)
    if (now - lastPlayedRef.current > 100) {
      audioEffects.playHover()
      lastPlayedRef.current = now
    }
  }

  return (
    <div className="tags">
      <h3>{title}</h3>
      <div className="tags-list">
        {tags.map((tag, index) => (
          <span 
            key={index} 
            className="tag"
            onMouseEnter={handleTagHover}
          >
            {tag}
          </span>
        ))}
      </div>
    </div>
  )
}

export default Tags
